import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import VendorService from "../../services/vendor.service";

export const getVendor = createAsyncThunk(
  "vendor/getVendor",
  async (params, thunkAPI) => {
    try {
      const response = await VendorService.getVendor(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addVendor = createAsyncThunk(
  "vendor/addVendor",
  async (data, thunkAPI) => {
    try {
      const response = await VendorService.addVendor(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updateVendor = createAsyncThunk(
  "vendor/updateVendor",
  async (payload, thunkAPI) => {
    try {
      const response = await VendorService.editVendor(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteVendor = createAsyncThunk(
  "vendor/deleteVendor",
  async (id, thunkAPI) => {
    try {
      await VendorService.deleteVendor(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =================== State =================== */

const initialState = {
  loading: false,
  error: null,
vendorList: {
  vendors: [],
  total: 0,
  page: 1,
},
  updateSuccess: false,
};

/* =================== Slice =================== */

const vendorSlice = createSlice({
  name: "vendor",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- Get ---------- */
      .addCase(getVendor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getVendor.fulfilled, (state, action) => {
        state.loading = false;
state.vendorList = {
  vendors: action.payload?.vendors || [],
  total: action.payload?.total || 0,
  page: action.payload?.page || 1,
};
      })
      .addCase(getVendor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add ---------- */
      .addCase(addVendor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addVendor.fulfilled, (state, action) => {
        state.loading = false;
        const newHotel =
          action.payload?.data ||
          action.payload?.vendors ||
          action.payload;

        if (newHotel) {
      state.vendorList.vendors.unshift(newHotel);
        }
      })
      .addCase(addVendor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update ---------- */
      .addCase(updateVendor.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateVendor.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const updated =
          action.payload?.data || action.payload?.vendors;

        if (updated?._id) {
         const index = state.vendorList.vendors.findIndex(
            (item) => item._id === updated._id
          );
          if (index !== -1) {
            state.vendorList[index] = updated;
          }
        }
      })
      .addCase(updateVendor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Delete ---------- */
      .addCase(deleteVendor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteVendor.fulfilled, (state, action) => {
        state.loading = false;
     state.vendorList.vendors = state.vendorList.vendors.filter(
  (item) => item._id !== action.payload
);
      })
      .addCase(deleteVendor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = vendorSlice.actions;
export default vendorSlice.reducer;
